// extracted by mini-css-extract-plugin
export default {"battery":"noDeviceAsssigned_battery__Qmkoh","blockNotification":"noDeviceAsssigned_blockNotification__0zZqn"};